<div (clickOutside)="clickedOutside($event)" id="bar" #bar class="slidersContainer dbarClass"
     (click)="clickedOnBar($event)" (touchmove)="touchMove($event)"
     (touchend)="mouseUp($event)">



    <span style="position:absolute" *ngIf="range && toolTip && toolTips[0]" [style.top.px]="toolTipTop" [style.left.px]="minSliderLeft">{{range[0]}}</span>
    <span style="position:absolute" *ngIf="range && toolTip && toolTips[1]" [style.top.px]="toolTipTop" [style.left.px]="maxSliderLeft">{{range[1]}}</span>
    <span style="position:absolute" *ngIf="range && combineToolTip" [style.top.px]="toolTipTop" [style.left.px]="combineToolTipLeft">{{range[0]}}-{{range[1]}}</span>

    <div #minSlider class="dslider minSlider dsliderClass" (mousedown)="minMouseDown($event)"
         [style.left.px]="minSliderLeft" (mouseup)="mouseUp($event)" (touchstart)="minTouched($event)">

    </div>

    <div #maxSlider class="dslider maxSlider dsliderClass" (mousedown)="maxMouseDown($event)"
         [style.left.px]="maxSliderLeft" (mouseup)="mouseUp($event)" (touchstart)="maxTouched($event)">

    </div>

    <div #sliderHilight class="sliderHilight dhighlightClass" (click)="clickedOnhighlight($event)"
         [style.width.px]="highlightWidth" [style.left.px]="highlightLeft"></div>
</div>
